var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFuturesAccount = function SvgFuturesAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.168 18.333-.256-.013a2.5 2.5 0 0 1-2.244-2.487V10h2.5zm14.165-3.704a3.704 3.704 0 0 1-3.703 3.704H5.833v-15h12.5zm-4.845-4.007-3.214-1.667-2.572 3.003 1.265 1.084 1.713-1.999 3.214 1.667 2.573-3.002-1.265-1.084z"
  })));
};
export default SvgFuturesAccount;